'use client';

import { c as _c } from "react/compiler-runtime";
import '@/styles/image-zoom.css';
import 'react-medium-image-zoom/dist/styles.css';
import Zoom from 'react-medium-image-zoom';
type ImageZoomProps = React.ComponentProps<typeof Zoom> & {
  children: React.ReactNode;
};
export function ImageZoom(props) {
  const $ = _c(6);
  let children;
  let rest;
  if ($[0] !== props) {
    ({
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== children || $[4] !== rest) {
    t0 = <Zoom zoomMargin={40} {...rest}>{children}</Zoom>;
    $[3] = children;
    $[4] = rest;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}